export default "__VITE_PUBLIC_ASSET__4f8395f8__"